module.exports = __webpack_public_path__ + "static/media/buzon-rojo-detalles.bd8adb5c.png";